export default __webpack_public_path__ + "static/room-1d2ffbf123c2dd93d44ba80bf6bd494c.webp";